module.exports = __webpack_public_path__ + "img/kevin_sprint_planning.67e91328.jpg";